"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_bootstrap_icons_1 = require("react-bootstrap-icons");
const react_router_dom_1 = require("react-router-dom");
const personCircle_svg_1 = __importDefault(require("../../../assets/images/personCircle.svg"));
const do_not_disturb_svg_1 = __importDefault(require("../../../assets/images/do-not-disturb.svg"));
const underline_1 = __importDefault(require("../../../components/underline"));
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
const logoutUser_1 = require("../../../utils/logoutUser");
require("./SideMenu.scss");
const SideMenuStyles_1 = require("./SideMenuStyles");
const PERFIL = 'perfil';
const RESERVES = 'reservas';
const SERVICES = 'servicos';
const MOBILE_WIDTH = 992;
const SideMenu = ({ name }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { subPath } = (0, react_router_dom_1.useRouteMatch)().params;
    const { isMobile } = (0, detectDevice_1.default)(MOBILE_WIDTH);
    const [opened, setOpened] = (0, react_1.useState)(false);
    const [mobileTitle, setMobileTitle] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        document.title = `360 Suítes - Área do Hospede`;
    }, []);
    (0, react_1.useEffect)(() => {
        switch (subPath) {
            case PERFIL:
                setMobileTitle('Informações pessoais');
                break;
            case RESERVES:
                setMobileTitle('Hospedagens');
                break;
            case SERVICES:
                setMobileTitle('Serviços');
                break;
            default:
                setMobileTitle('Serviços');
        }
    }, [subPath]);
    const mobileContent = (react_1.default.createElement("div", { className: "mobile-content SideMenu" },
        react_1.default.createElement("div", { className: `mobile-menu ${opened ? 'opened-sideMenu' : ''}` },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null, "Perfil"),
                react_1.default.createElement("hr", { className: "divider" }),
                react_1.default.createElement("div", { className: "mobile-link-list" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: `${RoutesPaths_1.routesPaths.myAccount}/${PERFIL}`, onClick: () => setOpened(!opened) },
                        react_1.default.createElement(SideMenuStyles_1.ListItem, { active: subPath === PERFIL },
                            react_1.default.createElement(react_bootstrap_icons_1.Person, { size: 20, fill: subPath === PERFIL ? '#C31C4A' : '#000' }),
                            react_1.default.createElement(SideMenuStyles_1.Text, { active: subPath === PERFIL }, "Informa\u00E7\u00F5es pessoais"))),
                    react_1.default.createElement(react_router_dom_1.Link, { to: `${RoutesPaths_1.routesPaths.myAccount}/${RESERVES}`, onClick: () => setOpened(!opened) },
                        react_1.default.createElement(SideMenuStyles_1.ListItem, { active: subPath === RESERVES },
                            react_1.default.createElement(react_bootstrap_icons_1.BookHalf, { size: 20, fill: subPath === RESERVES ? '#C31C4A' : '#000' }),
                            react_1.default.createElement(SideMenuStyles_1.Text, { active: subPath === RESERVES }, "Minhas Reservas"))),
                    react_1.default.createElement(react_router_dom_1.Link, { to: `${RoutesPaths_1.routesPaths.myAccount}/${SERVICES}`, onClick: () => setOpened(!opened) },
                        react_1.default.createElement(SideMenuStyles_1.ListItem, { active: subPath === SERVICES },
                            react_1.default.createElement("img", { src: do_not_disturb_svg_1.default, className: `list-item-icon ${subPath === SERVICES ? 'active' : ''}` }),
                            react_1.default.createElement(SideMenuStyles_1.Text, { active: subPath === SERVICES }, "Servi\u00E7os")))),
                react_1.default.createElement("hr", null),
                react_1.default.createElement(SideMenuStyles_1.ListItem, { onClick: () => (0, logoutUser_1.handleLogout)(history, undefined, true) },
                    react_1.default.createElement(react_bootstrap_icons_1.BoxArrowRight, { size: 20 }),
                    react_1.default.createElement(SideMenuStyles_1.Text, null, "Sair")),
                react_1.default.createElement("div", { className: "mobile-nav-button", onClick: () => setOpened(!opened) }, `${opened ? '<' : '>'}`))),
        react_1.default.createElement(SideMenuStyles_1.MobileContainer, null,
            react_1.default.createElement(SideMenuStyles_1.Text, { id: "mobile-title" }, mobileTitle),
            react_1.default.createElement(underline_1.default, { id: "mobile-underline" }),
            subPath === PERFIL && (react_1.default.createElement(SideMenuStyles_1.Group, null,
                react_1.default.createElement("img", { src: personCircle_svg_1.default, alt: "user-icon" }),
                react_1.default.createElement("span", null, `Olá, ${name}`))),
            react_1.default.createElement("hr", null))));
    const desktopContent = (react_1.default.createElement(SideMenuStyles_1.Container, { className: "SideMenu" },
        react_1.default.createElement(SideMenuStyles_1.Group, null,
            react_1.default.createElement("img", { src: personCircle_svg_1.default, alt: "user-icon" }),
            react_1.default.createElement("span", null, `Olá, ${name}`)),
        react_1.default.createElement(SideMenuStyles_1.Divider, null),
        react_1.default.createElement(antd_1.List, { style: { height: '30vh' } },
            react_1.default.createElement(react_router_dom_1.Link, { to: `${RoutesPaths_1.routesPaths.myAccount}/${PERFIL}` },
                react_1.default.createElement(SideMenuStyles_1.ListItem, { active: subPath === PERFIL },
                    react_1.default.createElement(react_bootstrap_icons_1.Person, { size: 20, fill: subPath === PERFIL ? '#C31C4A' : '#000' }),
                    react_1.default.createElement(SideMenuStyles_1.Text, { active: subPath === PERFIL }, "Informa\u00E7\u00F5es pessoais"))),
            react_1.default.createElement(react_router_dom_1.Link, { to: `${RoutesPaths_1.routesPaths.myAccount}/${RESERVES}` },
                react_1.default.createElement(SideMenuStyles_1.ListItem, { active: subPath === RESERVES },
                    react_1.default.createElement(react_bootstrap_icons_1.BookHalf, { size: 20, fill: subPath === RESERVES ? '#C31C4A' : '#000' }),
                    react_1.default.createElement(SideMenuStyles_1.Text, { active: subPath === RESERVES }, "Minhas Reservas"))),
            react_1.default.createElement(react_router_dom_1.Link, { to: `${RoutesPaths_1.routesPaths.myAccount}/${SERVICES}` },
                react_1.default.createElement(SideMenuStyles_1.ListItem, { active: subPath === SERVICES },
                    react_1.default.createElement("img", { src: do_not_disturb_svg_1.default, className: `list-item-icon ${subPath === SERVICES ? 'active' : ''}` }),
                    react_1.default.createElement(SideMenuStyles_1.Text, { active: subPath === SERVICES }, "Servi\u00E7os")))),
        react_1.default.createElement(SideMenuStyles_1.Divider, null),
        react_1.default.createElement(antd_1.List, null,
            react_1.default.createElement(SideMenuStyles_1.ListItem, null,
                react_1.default.createElement(react_1.default.Fragment, null)),
            react_1.default.createElement(SideMenuStyles_1.ListItem, { onClick: () => (0, logoutUser_1.handleLogout)(history, undefined, true) },
                react_1.default.createElement(react_bootstrap_icons_1.BoxArrowRight, { size: 20 }),
                react_1.default.createElement(SideMenuStyles_1.Text, null, "Sair")))));
    return (react_1.default.createElement("div", { style: !isMobile ? { height: '100vh' } : {} }, isMobile ? react_1.default.createElement(react_1.default.Fragment, null, mobileContent) : react_1.default.createElement(react_1.default.Fragment, null, desktopContent)));
};
exports.default = SideMenu;
